import moment from 'moment';
import 'moment/locale/en-gb';

moment.locale("en-gb");

// Formats: https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/

export function GetDate(timestamp: string) {
    return moment(timestamp);
}

export function GetDateTimeFromTimestamp(timestamp: string | null | undefined, format: string) {
    if (timestamp) {
        let dateTime = moment(timestamp);
        return dateTime.format(format);
    } else {
        return "N/A";
    }
}

export function GetDateTimeFromTimestampRounded(timestamp: string, format: string){
    let dateTime = moment(timestamp);
    if (dateTime.minute() >= 0 && dateTime.minute() <= 14){
        dateTime.set({minute: 0});
        }
    else if (dateTime.minute() >= 15 && dateTime.minute() <= 29){
        dateTime.set({minute: 15});
    }
    else if (dateTime.minute() >= 30 && dateTime.minute() <= 44){
        dateTime.set({minute: 30});
    }
    else if (dateTime.minute() >= 45 && dateTime.minute() <= 59){
        dateTime.set({minute: 45});
    }

    return dateTime.format(format);
}
export function GetDiffFromTimestamp(timestamp: string) {
    let dateTime = moment(timestamp);
    let now = moment();
    
    let duration = moment.duration(now.diff(dateTime));
    
    return duration.asMinutes();
}

export function GetLongDateFormat(timestamp: string) {
    return moment(timestamp).format("dddd, Do MMMM YYYY");
}

export function GetShortDateFormat(timestamp: string) {
    return moment(timestamp).format("LT");
}

export function GetGreeting(): string {
    let now = moment().hour();
    if (now < 12) {return "Hi"}
    else if (now < 17) {return "Hi"}
    else {return "Hi"}
}

export function Moment() {
    return moment();
}